import { render, staticRenderFns } from "./pageEspacePersonnel.vue?vue&type=template&id=6a24dfae&scoped=true"
import script from "./pageEspacePersonnel.vue?vue&type=script&lang=js"
export * from "./pageEspacePersonnel.vue?vue&type=script&lang=js"
import style0 from "./pageEspacePersonnel.vue?vue&type=style&index=0&id=6a24dfae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24dfae",
  null
  
)

export default component.exports